/**
 * Sheet que sube solo lo necesario para mostrar su contenido (decisión global #10
 * del spec; patrón Ionic 8 "Sheet Modal > Auto Height").
 *
 * La clase global `auto-height-sheet` (global.scss) le da `--height: auto` al
 * ion-modal; con eso el breakpoint 1 significa "todo el contenido", no "toda la
 * pantalla". El componente del sheet no debe usar <ion-content> como raíz: ocupa
 * el 100% del alto y anula el auto-height. Usar un <div> y `:host { display: block; }`.
 */
export const AUTO_HEIGHT_SHEET_CLASS = 'auto-height-sheet';

const SHEET_DISMISSED_BREAKPOINT = 0;
export const SHEET_FULL_CONTENT_BREAKPOINT = 1;
export const AUTO_HEIGHT_SHEET_BREAKPOINTS = [SHEET_DISMISSED_BREAKPOINT, SHEET_FULL_CONTENT_BREAKPOINT];

export interface AutoHeightSheetOptions {
  readonly breakpoints: number[];
  readonly initialBreakpoint: number;
  readonly cssClass: string;
}

export function autoHeightSheetOptions(): AutoHeightSheetOptions {
  return {
    breakpoints: [...AUTO_HEIGHT_SHEET_BREAKPOINTS],
    initialBreakpoint: SHEET_FULL_CONTENT_BREAKPOINT,
    cssClass: AUTO_HEIGHT_SHEET_CLASS,
  };
}
